<template>
    <div id="app">
        <svgsprites></svgsprites>
        <router-view/>
    </div>
</template>

<script>
import Vue from 'vue'
import SvgSprites from '@/components/SvgSprites'

Vue.component('svgsprites', SvgSprites)

export default {
    name: 'App',
    metaInfo: {
        titleTemplate: '%s | 『寝ても覚めても』公開記念 濱口竜介アーリー・ワークス'
    }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue